import React, { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router'
import { Dialog3 as Dialog } from '@st-operations/uikit/src/v1/index.js'
import { Button, BUTTON_THEME } from '@st-operations/uikit/src/v2'

import './styles.scss'

export function RouterPrompt(props) {
  const { when, onOK, onCancel, title, description, okText, cancelText } = props

  const history = useHistory()

  const [showPrompt, setShowPrompt] = useState(false)
  const [currentPath, setCurrentPath] = useState('')

  useEffect(() => {
    if (when) {
      history.block((prompt) => {
        setCurrentPath(prompt.pathname)
        setShowPrompt(true)
        return false
      })
    } else {
      history.block(() => {})
    }
  }, [history, when])

  const handleOK = useCallback(async () => {
    if (onOK) {
      const canRoute = await Promise.resolve(onOK())
      if (canRoute) {
        history.block(() => {})
        history.push(currentPath)
        history.go(0)
      }
    }
  }, [currentPath, history, onOK])

  const handleCancel = useCallback(async () => {
    if (onCancel) {
      const canRoute = await Promise.resolve(onCancel())
      if (canRoute) {
        history.block(() => {})
        history.push(currentPath)
      }
    }
    setShowPrompt(false)
  }, [currentPath, history, onCancel])

  return (
    <If condition={showPrompt}>
      <Dialog open={showPrompt}>
        <div className="router-prompt__container">
          <h3>{title}</h3>
          <span>{description}</span>
          <div>
            <Button theme={BUTTON_THEME.GHOST} onClick={handleCancel}>
              {cancelText}
            </Button>
            <Button onClick={handleOK}>{okText}</Button>
          </div>
        </div>
      </Dialog>
    </If>
  )
}
